var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-none ml-2",attrs:{"small":"","outlined":"","color":"primary"},on:{"click":function($event){return _vm.setShowChart(!_vm.showChart)}}},[_vm._v(" "+_vm._s(_vm.showChart ? _vm.$t('hideChart') : _vm.$t('showChart'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }